import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { IconButton } from '@calendly/ui/components/icon-button';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wizardIsPhoneCss = "wiogp32";
const wizardCss = "w1o20fpm";
export const Wizard = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(wizardCss, {
    [wizardIsPhoneCss]: isPhone
  }, props.className)} />;
});
const headerCss = "h1dvmsyd";
export const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const calendlyLogoImgCss = "c95v34h";
export const CalendlyLogoImg = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(calendlyLogoImgCss, props.className)} />;
});
const closeButtonCss = "ceoi9jj";
export const CloseButton = forwardRef((props, ref) => <IconButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)} />);
const mobileCloseButtonCss = "m1i0ah95";
export const MobileCloseButton = forwardRef((props, ref) => <IconButton ref={ref} {...props} className={classNames(mobileCloseButtonCss, props.className)} />);
const bodyCss = "bv6bjs0";
export const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, props.className)} />;
});
const illustrationIsTabletUpCss = "iihyy0s";
const illustrationCss = "i1j63i25";
export const Illustration = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(illustrationCss, {
    [illustrationIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const titleContainerIsPhoneCss = "t19jd2h6";
const titleContainerIsTabletUpCss = "th7vru3";
const titleContainerIsSmallPhoneCss = "t1ytd5t5";
const titleContainerCss = "t1a0sjdz";
export const TitleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isSmallPhone = useDeviceType('isSmallPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(titleContainerCss, {
    [titleContainerIsPhoneCss]: isPhone,
    [titleContainerIsTabletUpCss]: isTabletUp,
    [titleContainerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const buttonContainerCss = "b1anbdgj";
export const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, props.className)} />;
});
const primaryButtonCss = "pkbpw9k";
export const PrimaryButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(primaryButtonCss, props.className)} />);
const secondaryButtonCss = "s1hd8vtu";
export const SecondaryButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(secondaryButtonCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");